import React from "react";

export const Bio = () => (
  <p className="bio">
    Shipping features at <span>Contentstack</span>. I write <span>code</span>{" "}
    for a living and take <span>photos</span> for fun. Somewhere between the
    two, I <span>just do things</span>.
  </p>
);
